<script lang="ts" setup>
import EmptyLayout from "../../../../packages/view/src/components/EmptyLayout.vue";
import Root from "../../../../packages/view/src/components/Root.vue";
import AppVersion from "../../view/components/AppVersion.vue";
</script>

<template>
  <Root>
    <EmptyLayout>
      <slot />
    </EmptyLayout>

    <AppVersion></AppVersion>
  </Root>
</template>
